import { render, staticRenderFns } from "./formSettings.vue?vue&type=template&id=7a087832&"
import script from "./formSettings.vue?vue&type=script&lang=js&"
export * from "./formSettings.vue?vue&type=script&lang=js&"
import style0 from "./formSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports